import React from 'react'
import PropTypes from 'prop-types'
import SearchSupportButton from './SearchSupportButton'

ContactSection.propTypes = {
  query: PropTypes.string.isRequired,
  hasResults: PropTypes.bool.isRequired
}

export default function ContactSection({ query, hasResults }) {
  const visible = isContactSearch(query) || !hasResults

  if (!visible) return null

  return <SearchSupportButton />
}

function isContactSearch(query) {
  const contactSearchTerms = ['chat', 'support', 'contact', 'kontakt']

  const queryTerms = query
    .trim()
    .toLowerCase()
    .split(' ')

  return queryTerms.some(queryTerm => contactSearchTerms.includes(queryTerm))
}
